export const configFile = {
  primaryAccentColor: "#EC7E83",
  secondaryAccentColor: "#FFE2E4",
  tertiaryAccentColor: "#BD6569",
  fourthAccentColor: "#843B3F",
  fifthAccentColor: "#F7CBCD"
};
